// Coerce an axios error into a stringifiable Error, preserving the backend
// error code (e.g. 'step_up_required') so callers can localize it. FastAPI
// `detail` is usually a string but can be an object (our step-up marker) or
// an array (422 validation), neither of which must reach `new Error`.
export const wrapApiError = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  let message;
  if (typeof detail === 'string') {
    message = detail;
  } else if (Array.isArray(detail)) {
    message = detail.map((d) => d?.msg).filter(Boolean).join('; ');
  } else if (detail && typeof detail === 'object') {
    message = detail.detail || detail.msg || detail.message;
  }
  if (!message) message = error?.response?.statusText || fallback;
  const wrapped = new Error(message);
  wrapped.code = error?.code || error?.response?.data?.code;
  wrapped.status = error?.response?.status;
  return wrapped;
};

// Resolve a user-facing message from a wrapped hook error: the localized
// step-up prompt when verification was cancelled/failed, otherwise the
// error's own message.
export const stepUpAwareMessage = (error, t, key = 'common.verificationRequired') =>
  error?.code === 'step_up_required' ? t(key) : (error?.message || '');
